import { Container, Stack, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { toast } from 'react-hot-toast';
import Content from '../public/Content';
import Cookies from 'universal-cookie';
import { fetchWith401Check } from '../../helpers/http';

// this will show the 1 page project to be generated into pdf
const ModerationPreview = () => {
  const cookies = new Cookies();
  const params = useParams();
  const [loadingState, setLoadingState] = React.useState(false);
  const [repository, setRepository] = React.useState({});

  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const fetchRepositoryByID = async () => {
    if (!params.id) return;
    if (!_.isEmpty(repository)) return;

    fetchWith401Check(`${API_URL}/tabledatas/summary/id?id=${params.id}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const repoData = response?.response || {};
        setRepository({ ...repository, ...repoData });
      })
      .catch(function (err) {
        return toast.error(err.message || 'Something wrong happenned');
      });
  };
  React.useEffect(() => {
    if (params?.id) fetchRepositoryByID();
  }, [params]);

  return (
    <Container>
      {!repository.id && <IDNotFound />}
      {repository.id && <Content />}
    </Container>
  );
};

const IDNotFound = () => {
  return (
    <Stack direction='column' alignItems='center'>
      <Typography>ID not found, please select the correct document.</Typography>
    </Stack>
  );
};

export default ModerationPreview;
